/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text } from './Text';
import { Title } from './Title';

const RebalanceOrSellError = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'sadFace'} />
      <Title>{t('NOTIFICATION_REBALANCE_OR_SELL_ERROR_MODAL__title')}</Title>
      <Text>{t('NOTIFICATION_REBALANCE_OR_SELL_ERROR_MODAL__desc')}</Text>
    </>
  );
};

export { RebalanceOrSellError };
